import SqftJsonApi from "../../../../../../../api/sqftJsonApi";
import {CrownMoldingPositions} from "../../../../../../../helpers/cabinetsData/CrownMoldingPositions";

class CrownMoldingLoader {
  constructor(scene, loader, modelScale) {
    this.scene = scene;
    this.modelScale = modelScale;
    this.loader = loader;
    this.moldingsByShapeId = new Map();
  }

  removeForShape(shapeId) {
    const moldings = this.moldingsByShapeId.get(shapeId);
    if (!moldings) return;
    moldings.forEach(m => this.scene.remove(m));
    this.moldingsByShapeId.delete(shapeId);
  }

  updatePositionForShape(shapeId) {
    const moldings = this.moldingsByShapeId.get(shapeId);
    if (!moldings || moldings.length === 0) return;

    const positions = CrownMoldingPositions.prepareCrownMoldingPositionsForTheShape(shapeId);
    positions.forEach((pos, i) => {
      if (moldings[i]) {
        moldings[i].position.set(
          pos.cabinet_position.x * this.modelScale,
          pos.posY * this.modelScale,
          pos.cabinet_position.y * this.modelScale,
        );
      }
    });
  }

  loadCrownMolding = async (shapeId, cabinetMaterial) => {
    this.removeForShape(shapeId);

    const crownMoldingPositions = CrownMoldingPositions.prepareCrownMoldingPositionsForTheShape(shapeId);

    if (crownMoldingPositions) {
      const loadedMoldings = [];

      const crownMoldingPromises = crownMoldingPositions.map(async (crownMoldingPosition) => {
        try {
          const crownMoldingURL = await SqftJsonApi.getCrownMolding(crownMoldingPosition, {});
          //console.log("crownMoldingURL", crownMoldingURL);
          if (crownMoldingURL && crownMoldingURL.s3Url) {
            const moldingModel = await this.loadMoldingModel(crownMoldingURL.s3Url);
            // Apply cabinet material to crown molding
            moldingModel.traverse((child) => {
              if (child.isMesh) {
                child.material = cabinetMaterial;
              }
            });

            //v1 adjust model size to position in workspace
            moldingModel.position.set(
              crownMoldingPosition.cabinet_position.x * this.modelScale,//wallPosition.x / this.modelScale,
              crownMoldingPosition.posY * this.modelScale, //wallPosition.y / this.modelScale,
              crownMoldingPosition.cabinet_position.y * this.modelScale, //wallPosition.z / this.modelScale
            );

            //moldingModel.rotation.y = THREE.MathUtils.degToRad(molding.rotation);

            this.scene.add(moldingModel);
            loadedMoldings.push(moldingModel);
          } else {
            console.log(`No URL for crownMolding at position: ${crownMoldingPosition}`);
          }
        } catch (error) {
          console.error(`Failed to get crownMolding data for position ${crownMoldingPosition}`, error);
        }
      });

      const result = await Promise.all(crownMoldingPromises);
      this.moldingsByShapeId.set(shapeId, loadedMoldings);
      return result;
    }
  }

  loadMoldingModel(url) {
    return new Promise((resolve, reject) => {
      this.loader.load(
        url,
        (gltf) => resolve(gltf.scene),
        undefined,
        (error) => reject(error)
      );
    });
  }
}

export default CrownMoldingLoader;
